import { useEffect, useState } from 'preact/hooks';

import { getTracerModules } from '@apptracer/sdk/lite';

import { useStompClient } from 'react-stomp-hooks';

import { packageName } from '../../config';

interface SendMessage<T> {
  destination: string;
  body: T;
}

interface UseStompSenderParams {
  onAfterPublish?: () => void;
}
interface UseStompSenderReturn<T> {
  send: (params: SendMessage<T>) => void;
  pendingCount: number;
  flushQueue: () => void;
}

export function useStompSender<T>({ onAfterPublish }: UseStompSenderParams): UseStompSenderReturn<T> {
  const stompClient = useStompClient();
  const [queue, setQueue] = useState<SendMessage<T>[]>([]);

  const tracerError = getTracerModules(packageName).error;

  const send = (params: SendMessage<T>) => {
    const { body, destination } = params;

    if (stompClient?.connected) {
      try {
        stompClient.publish({
          destination,
          body: JSON.stringify(body),
        });

        onAfterPublish?.();
      } catch (_) {
        tracerError?.error('Не удалось отправить сообщение');

        setQueue((prev) => [...prev, { destination, body }]);
      }
    } else {
      setQueue((prev) => [...prev, { destination, body }]);
    }
  };

  const flushQueue = (): void => {
    if (stompClient?.connected && queue.length > 0) {
      queue.forEach(({ destination, body }) => {
        try {
          stompClient.publish({
            destination,
            body: JSON.stringify(body),
          });
        } catch (_) {
          tracerError?.error('Не удалось отправить сообщение из очереди');
          // Оставляем сообщение в очереди, если отправка не удалась
          return;
        }
      });
      onAfterPublish?.();
      setQueue([]);
    }
  };

  // Автоматически отправляем очередь, когда появляется соединение
  useEffect(() => {
    if (stompClient?.connected) {
      flushQueue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stompClient?.connected]);

  return {
    send,
    pendingCount: queue.length,
    flushQueue,
  };
}
